import React, { useState } from "react";
import Approval from "../../assets/svg/Approval";
import { useNavigate } from "react-router-dom";

export const BusinessPermit = ({ handleClose }) => {
  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate("/account/personal");
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-xs">
      <div className="bg-white rounded-lg max-w-md w-full mx-4 p-6 relative overflow-y-auto max-h-[90vh]">
        <div className="flex flex-col items-center space-y-8">
          <Approval className="w-full max-w-xs" />
          <div className="text-center">
            <h2 className="text-lg font-semibold">
              Earn a “Recognized Badge”!
            </h2>
            <p className="text-sm mt-2" style={{ color: "#4B5563" }}>
              Upload your business permit for approval. Once uploaded, please
              give us 24 hours to confirm the validity of your documents.
            </p>
          </div>
        </div>
        <div className="mx-4 mt-8 flex space-x-2">
          <button
            className="flex-1 py-3 font-semibold text-sunrise-500 bg-white"
            onClick={handleClose}
          >
            Do it later
          </button>
          <button
            className="flex-1 py-3 rounded-xl bg-primary-500 text-white font-semibold hover:opacity-90"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};
